export const LANGUAGE = {
  JP: 'JAPANESE',
  EN: 'ENGLISH',
}
